import { useNavigate } from "react-router-dom";

//Iconos
import { FaRegEdit } from 'react-icons/fa'
import { listaEstadosActivo, listaEstadosActivoBusqueda } from "../../../app/constants/constants-selectores";
import { RiDeleteBinFill } from 'react-icons/ri'

import Swal from 'sweetalert2';
import { companiaDelete, companiaMostrar } from "../../companias";
import { useContext, useEffect, useState } from "react";
import { obtenerLabel, obtenerLocalStorage } from "../../../shared/utils/funciones";
import { DataContext } from "../../../app/providers/DataContext";

import { IoMdAdd } from "react-icons/io"
import { BiSearch } from "react-icons/bi"
import { useMobileDetection } from "../../../shared/hooks/useMobileDetection";
import { CONST_KEY_USUARIO_AUTENTICADO, CONST_ROL_MASTER } from "../../../app/constants/constanst-valores";
import { validarAutenticacion } from "../../auth";
import { CONST_CODIGO_SUCURSALES_AGREGAR, CONST_CODIGO_SUCURSALES_EDITAR, CONST_CODIGO_SUCURSALES_ELIMINAR, CONST_RUTA_SIN_ACCESO, CONST_RUTA_SUCURSALES_AGREGAR, CONST_RUTA_SUCURSALES_EDITAR, CONST_RUTA_SUCURSALES_LISTAR } from "../../../app/constants/constants-rutas-codigos";
import { useRefetchAlCerrarModal } from "../../../shared/hooks/useRefetchAlCerrarModal";

import { useForm } from 'react-hook-form';
import { sucursalesBuscar } from "../api/sucursales.api";
import { usuarioObtenerCompaniasYSucursales } from "../../usuarios";
import { TablaSkeleton } from "../../../shared/ui/TablaSkeleton";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const Sucursales = () => {

    const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);
    const rol = usuarioAutenticado?.tipo

    const { listaRutasDeAcceso } = useContext(DataContext)

    const [listaCompanias, setListaCompanias] = useState([])
    const isMobile = useMobileDetection()

    //Estados para ver si mostrar o no los botones
    const [mostrarBotonAgregar, setMostrarBotonAgregar] = useState(false)
    const [mostrarBotonEditar, setMostrarBotonEditar] = useState(false)
    const [mostrarBotonEliminar, setMostrarBotonEliminar] = useState(false)

    const { register, handleSubmit, watch, setValue } = useForm<any>({
        defaultValues: {
            Estado: "A",
        }
    });

    // ítem 15 (React Query, fase 2): el listado se sirve vía useQuery, no useState.
    // `filtrosAplicados` (null = sin buscar) codifica también el MODO de fetch, porque este
    // listado bifurca: modo "buscar" (sucursalesBuscar por Estado/Codigo — master o >1 compañía)
    // vs modo "single" (companiaMostrar — no-master con 1 sola compañía). El modo va en la clave.
    const queryClient = useQueryClient()
    const [filtrosAplicados, setFiltrosAplicados] = useState<any>(null)

    const { data: sucursalesData, isFetching } = useQuery({
        queryKey: ["seg-sucursales", filtrosAplicados],
        queryFn: async () => {
            if (filtrosAplicados?.modo === "single") {
                const { compania } = await companiaMostrar({ compania: filtrosAplicados?.compania, token: usuarioAutenticado?.token })
                return { companias: [compania] }
            }
            return sucursalesBuscar({ Estado: filtrosAplicados?.Estado, Codigo: filtrosAplicados?.Codigo, token: usuarioAutenticado?.token })
        },
        enabled: filtrosAplicados !== null,
    })

    // Derivados (equivalentes 1:1 a listaSucursales/isLoading/buscar).
    const listaSucursales: any[] = sucursalesData?.companias ?? []
    const isLoading = isFetching
    const buscar = filtrosAplicados !== null

    const onSubmitBuscar = (data) => {
        // Búsqueda master: fija filtros del form; useQuery re-consulta. invalidate = paridad
        // con el flujo previo (siempre re-consultaba al pulsar buscar, aunque no cambien).
        setFiltrosAplicados({ modo: "buscar", Estado: data?.Estado, Codigo: data?.compania })
        queryClient.invalidateQueries({ queryKey: ["seg-sucursales"] })
    }

    const navigate = useNavigate()

    const companiaAgregar = async () => {

        const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, CONST_CODIGO_SUCURSALES_AGREGAR)

        if (validarAutenticado) {
            navigate(CONST_RUTA_SUCURSALES_AGREGAR)
        } else {
            navigate(CONST_RUTA_SIN_ACCESO)
        }

    }

    const companiaEditar = async (CodCompania) => {

        const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, CONST_CODIGO_SUCURSALES_EDITAR)

        if (validarAutenticado) {

            const dataPOST = {
                compania: CodCompania,
                token: usuarioAutenticado?.token
            }

            const { compania } = await companiaMostrar(dataPOST)

            navigate(CONST_RUTA_SUCURSALES_EDITAR, {
                state: compania
            })

        } else {
            navigate(CONST_RUTA_SIN_ACCESO)
        }
    }

    const optionsEliminar = (nombreCompania): any => {
        return {
            title: `¿Estás seguro de eliminar la compañía: ${nombreCompania}?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#6c757d',
            confirmButtonColor: '#d33',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
        }
    }

    const companiaEliminar = (compania, nombreCompania) => {

        Swal.fire(optionsEliminar(nombreCompania)).then(async (result) => {
            if (result.isConfirmed) {

                const dataPOST = {
                    compania,
                    token: usuarioAutenticado?.token
                }
                const { status } = await companiaDelete(dataPOST)
                if (status === 1) {
                    sucursalesBuscarActivos()
                    // getDataSelector()
                    Swal.fire(
                        'Compañía eliminado',
                        '',
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Error al eliminar compañía',
                        '',
                        'success'
                    )
                }

            }
        })

    }

    // Preserva 1:1 la bifurcación original: master o >1 compañía → modo "buscar" (watch);
    // no-master con 1 compañía → modo "single" (companiaMostrar). Sin arg y no-master → NO refresca
    // (mismo comportamiento previo). Cada rama invalida para forzar re-fetch fresco.
    const sucursalesBuscarActivos = (sucursales?) => {

        if (rol === CONST_ROL_MASTER || sucursales?.length > 1) {
            setFiltrosAplicados({ modo: "buscar", Estado: watch("Estado"), Codigo: watch("compania") })
            queryClient.invalidateQueries({ queryKey: ["seg-sucursales"] })
        } else if (sucursales?.length === 1) {
            setFiltrosAplicados({ modo: "single", compania: sucursales?.[0]?.id })
            queryClient.invalidateQueries({ queryKey: ["seg-sucursales"] })
        }

    }

    const obtenerCompaniasYSucursales = async () => {

        const dataPOST = {
            token: usuarioAutenticado?.token
        }

        const { companias, sucursales } = await usuarioObtenerCompaniasYSucursales(dataPOST)
        setListaCompanias(companias)
        setValue("compania", companias?.[0]?.id)

        return {
            companias,
            sucursales
        }
    }

    useEffect(() => {

        const encontradoRutaBotonAgregar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_SUCURSALES_AGREGAR)
        const encontradoRutaBotonEditar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_SUCURSALES_EDITAR)
        const encontradoRutaBotonEliminar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_SUCURSALES_ELIMINAR)

        encontradoRutaBotonAgregar ? setMostrarBotonAgregar(true) : setMostrarBotonAgregar(false)
        encontradoRutaBotonEditar ? setMostrarBotonEditar(true) : setMostrarBotonEditar(false)
        encontradoRutaBotonEliminar ? setMostrarBotonEliminar(true) : setMostrarBotonEliminar(false)

    }, [listaRutasDeAcceso])

    useEffect(() => {

        const cargarDatosIniciales = async () => {
            const { sucursales } = await obtenerCompaniasYSucursales()
            sucursalesBuscarActivos(sucursales)
        };

        cargarDatosIniciales();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // carga inicial (una sola vez al montar)

    // Al cerrar el modal (agregar/editar) se refresca SOLO la tabla con los filtros
    // actuales; NO se re-consultan los catálogos, así el select de Compañía del filtro
    // conserva su valor y sus opciones (no se "pierde").
    useRefetchAlCerrarModal(CONST_RUTA_SUCURSALES_LISTAR, sucursalesBuscarActivos)

    return (
        <div className="p-3">
            <div className="container-fluid">
                <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Sucursal</h3>

                {/* Formulario */}
                {
                    rol === CONST_ROL_MASTER && (
                        <div className="tw-mb-4 tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-md tw-border tw-border-gray-100">
                            <form onSubmit={handleSubmit(onSubmitBuscar)} className="row g-2">

                                <div className="col-12 col-lg-7">
                                    <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Compañía</label>
                                    <select
                                        {...register("compania", {
                                            required: true
                                        })} className="form-select form-select-sm"
                                        value={watch("compania")}
                                    >
                                        {
                                            listaCompanias?.length > 0 && listaCompanias.map(e => (
                                                <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div className="col-12 col-lg-4">
                                    <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Estado</label>
                                    <select {...register("Estado")} className="form-select form-select-sm" >
                                        {
                                            listaEstadosActivoBusqueda?.length > 0 && listaEstadosActivoBusqueda.map(e => (
                                                <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div className="col-12 col-lg-1">
                                    <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">&nbsp;</label>
                                    <div className={isMobile ? "text-center" : ""}>
                                        <button type="submit" onClick={handleSubmit(onSubmitBuscar)} style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
                                            <BiSearch size={25} className="color-iconos" />
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div >
                    )
                }

                {/* Fin formulario */}

                {
                    mostrarBotonAgregar && (
                        <div className="mx-auto ps-0">
                            <button className='btn btn-primario btn-sm align-middle d-flex align-items-center' onClick={companiaAgregar}>
                                <IoMdAdd size={18} />
                                <span className="ms-1">Agregar</span>
                            </button>
                        </div>

                    )
                }


                {/* Tabla de resultados */}
                <div className="tw-mt-2 tw-rounded-2xl tw-bg-white tw-p-3 tw-shadow-md tw-border tw-border-gray-100 tw-overflow-x-auto">
                    <table className="table table-hover tw-mb-0">
                        <thead className="table-light">
                            <tr>
                                <th scope="col" className="col text-center">Código</th>
                                <th scope="col" className="col text-center">RUC</th>
                                <th scope="col" className="col text-center">Sucursal</th>
                                <th scope="col" className="col text-center">Razon social</th>
                                <th scope="col" className="col text-center">Estado</th>
                                {
                                    mostrarBotonEditar && (
                                        <th scope="col" className="col text-center">Editar</th>
                                    )
                                }
                                {
                                    mostrarBotonEliminar && (
                                        <th scope="col" className="col text-center">Eliminar</th>
                                    )
                                }
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "" : "tabla-fade-in"}>

                            {
                                (isLoading && !listaSucursales?.length) ? (
                                    <TablaSkeleton rows={6} cols={6} />

                                ) : (
                                    listaSucursales?.length > 0 ? listaSucursales.map(c => (
                                        <tr key={c?.CompCod}>
                                            <td>{c?.CompCod}</td>
                                            <td>{c?.CompRuc}</td>
                                            <td>{c?.CompNom}</td>
                                            <td>{c?.CompRSoc}</td>
                                            <td>{obtenerLabel(listaEstadosActivo, c?.CompEst)}</td>
                                            {
                                                mostrarBotonEditar && (
                                                    <td><FaRegEdit size={23} cursor={'pointer'} className="color-iconos" onClick={() => companiaEditar(c?.CompCod)} /></td>
                                                )
                                            }
                                            {
                                                mostrarBotonEliminar && (
                                                    <td><RiDeleteBinFill size={23} cursor={'pointer'} color="#C0392B" onClick={() => companiaEliminar(c?.CompCod, c?.CompNom)} /></td>
                                                )
                                            }

                                        </tr>
                                    )) :
                                        (
                                            (buscar) ? (
                                                <tr>
                                                    <td colSpan={100} className="text-center">No hay sucursales</td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan={100} className="text-center">Realice una búsqueda</td>
                                                </tr>
                                            )
                                        )
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {/* Fin Tabla de resultados */}

            </div>
        </div>
    )
}
